import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () =>
      import(
        /* webpackChunkName: "PrivacyPolicy" */ "../views/blankPage/index.vue"
      ),
    meta: {
      title: "404",
    },
  },
  {
    path: "/agreement/PrivacyPolicy",
    component: () =>
      import(
        /* webpackChunkName: "PrivacyPolicy" */ "../views/agreement/PrivacyPolicy.vue"
      ),
    meta: {
      title: "隐私政策",
    },
  },
  {
    path: "/agreement/UserAgreement",
    component: () =>
      import(
        /* webpackChunkName: "UserAgreement" */ "../views/agreement/UserAgreement.vue"
      ),
    meta: {
      title: "用户协议",
    },
  },
  {
    path: "/agreement/PrivacyPolicySort",
    name: "PrivacyPolicySort",
    component: () =>
      import(
        /* webpackChunkName: "PrivacyPolicySort" */ "../views/agreement/PrivacyPolicySort.vue"
      ),
    meta: {
      title: "隐私政策指引摘要",
    },
  },
  {
    path: "/agreement/PersonalInformationCollectionChecklist",
    name: "PersonalInformationCollectionChecklist",
    component: () =>
      import(
        /* webpackChunkName: "PersonalInformationCollectionChecklist" */ "../views/agreement/PersonalInformationCollectionChecklist.vue"
      ),
    meta: {
      title: "个人信息收集清单",
    },
  },
  {
    path: "/agreement/UserProfileInformation",
    name: "UserProfileInformation",
    component: () =>
      import(
        /* webpackChunkName: "UserProfileInformation" */ "../views/agreement/UserProfileInformation.vue"
      ),
    meta: {
      title: "用户资料信息",
    },
  },
  {
    path: "/agreement/ServiceInformation",
    name: "ServiceInformation",
    component: () =>
      import(
        /* webpackChunkName: "ServiceInformation" */ "../views/agreement/ServiceInformation.vue"
      ),
    meta: {
      title: "语音社区用户服务内容信息",
    },
  },
  {
    path: "/agreement/EquipmentInformation",
    component: () =>
      import(
        /* webpackChunkName: "EquipmentInformation" */ "../views/agreement/EquipmentInformation.vue"
      ),
    meta: {
      title: "语音社区设备信息",
    },
  },
  {
    path: "/agreement/SDKList",
    name: "SDKList",
    component: () =>
      import(
        /* webpackChunkName: "SDKList" */ "../views/agreement/SDKList.vue"
      ),
    meta: {
      title: "语音社区第三方SDK列表",
    },
  },

  {
    path: "/h5Page",
    name: "h5Page",
    component: () =>
      import(/* webpackChunkName: "h5Page" */ "../views/h5Page/index.vue"),
    meta: {
      title: "33",
    },
  },
  {
    path: "/article/:type",
    name: "h5Page",
    component: () =>
      import(/* webpackChunkName: "h5Page" */ "../views/wxshare/index.vue"),
    props: true,

    meta: {
      title: "语音社区",
    },
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  console.log(to);

  document.title = to.meta.title || "语音社区";
  next();
});
export default router;
